export var Locale;
(function (Locale) {
    Locale["CS"] = "cs";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));
export var LocaleTrans;
(function (LocaleTrans) {
    LocaleTrans["WHITE"] = "B\u00EDl\u00E1";
    LocaleTrans["BLACK"] = "\u010Cern\u00E1";
    LocaleTrans["SILVER"] = "St\u0159\u00EDbrn\u00E1";
    LocaleTrans["GRAY"] = "\u0160ediv\u00E1";
    LocaleTrans["RED"] = "\u010Cerven\u00E1";
    LocaleTrans["BLUE"] = "Modr\u00E1";
    LocaleTrans["GREEN"] = "Zelen\u00E1";
    LocaleTrans["YELLOW"] = "\u017Dlut\u00E1";
    LocaleTrans["BROWN"] = "Hn\u011Bd\u00E1";
    LocaleTrans["VIOLET"] = "Fialov\u00E1";
    LocaleTrans["ORANGE"] = "Oran\u017Eov\u00E1";
    LocaleTrans["GOLD"] = "Zlat\u00E1";
    LocaleTrans["BEIGE"] = "B\u00E9\u017Eov\u00E1";
    LocaleTrans["BRONZE"] = "Bronzov\u00E1";
    LocaleTrans["PINK"] = "R\u016F\u017Eov\u00E1";
    LocaleTrans["TRANSPARENT"] = "Pr\u016Fhledn\u00E1";
    LocaleTrans["TURQUOISE"] = "Tyrkysov\u00E1";
    LocaleTrans["HATCHBACK"] = "Hatchback";
    LocaleTrans["LIFTBACK"] = "Liftback";
    LocaleTrans["FASTBACK"] = "Fastback";
    LocaleTrans["COMBI"] = "Kombi";
    LocaleTrans["SEDAN"] = "Sedan";
    LocaleTrans["SUV"] = "SUV";
    LocaleTrans["SUV_COUPE"] = "SUV Coup\u00E9";
    LocaleTrans["CROSSOVER"] = "Crossover";
    LocaleTrans["MPV"] = "MPV";
    LocaleTrans["COUPE"] = "Coup\u00E9";
    LocaleTrans["CONVERTIBLE"] = "Kabriolet";
    LocaleTrans["GRAND_COUPE"] = "Grand Coup\u00E9";
    LocaleTrans["SHOOTING_BRAKE"] = "Shooting Brake";
    // PETROL_95
    // PETROL_95_MILD_HYBRID
    // PETROL_98
    // PETROL_98_MILD_HYBRID
    LocaleTrans["PETROL"] = "Benz\u00EDn";
    // PETROL_95_PLUG_IN_HYBRID
    // PETROL_95_HYBRID
    // PETROL_98_PLUG_IN_HYBRID
    // PETROL_98_HYBRID
    LocaleTrans["PETROL_HYBRID"] = "Benz\u00EDn Hybrid";
    // DIESEL
    // DIESEL_MILD_HYBRID
    LocaleTrans["DIESEL"] = "Diesel";
    // CNG
    LocaleTrans["CNG"] = "CNG";
    // ELECTRIC
    LocaleTrans["ELECTRIC"] = "Elekt\u0159ina";
    LocaleTrans["PETROL_95"] = "Benz\u00EDn 95";
    LocaleTrans["PETROL_95_PLUG_IN_HYBRID"] = "Benz\u00EDn 95 Plug-in Hybrid";
    LocaleTrans["PETROL_95_HYBRID"] = "Benz\u00EDn 95 Hybrid";
    LocaleTrans["PETROL_95_MILD_HYBRID"] = "Benz\u00EDn 95 Mild Hybrid";
    LocaleTrans["PETROL_98"] = "Benz\u00EDn 98";
    LocaleTrans["PETROL_98_PLUG_IN_HYBRID"] = "Benz\u00EDn 98 Plug-in Hybrid";
    LocaleTrans["PETROL_98_HYBRID"] = "Benz\u00EDn 98 Hybrid";
    LocaleTrans["PETROL_98_MILD_HYBRID"] = "Benz\u00EDn 98 Mild Hybrid";
    LocaleTrans["DIESEL_MILD_HYBRID"] = "Diesel Mild Hybrid";
    LocaleTrans["FRONT"] = "P\u0159edn\u00EDch kol";
    LocaleTrans["REAR"] = "Zadn\u00EDch kol";
    LocaleTrans["ALL"] = "V\u0161ech kol";
    LocaleTrans["MANUAL"] = "Manu\u00E1ln\u00ED";
    LocaleTrans["AUTOMAT"] = "Automatick\u00E1";
    LocaleTrans["SPORT_AUTOMAT"] = "Sportovn\u00ED Automatick\u00E1";
})(LocaleTrans || (LocaleTrans = {}));
